module.exports = __webpack_public_path__ + "static/media/5.5f5ed067.png";